import React from 'react';
import { Link } from 'react-router-dom';
export function AboutCTA() {
  return <section className="py-16 px-4 bg-[#0f1f3d] text-white text-center" data-id="element-212">
      <div className="max-w-3xl mx-auto" data-id="element-213">
        <h2 className="text-3xl font-bold mb-6" data-id="element-214">Ready to join our family?</h2>
        <p className="text-gray-300 mb-8 text-lg" data-id="element-215">
          Experience the difference dedicated instruction makes.
        </p>
        <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-216">
          Start Your Trial Today
        </Link>
      </div>
    </section>;
}